
export default {
  // Profile
  "profile_reviews": "리뷰",
  "profile_no_reviews": "아직 리뷰가 없습니다",
  "profile_share_experience": "필름 커뮤니티와 당신의 경험을 공유하세요!",
  "verified_traveler": "인증된 여행자",
  "verified_creative": "인증된 크리에이티브",
  "verified_traveler_tooltip": "이 사용자는 인증된 여행자입니다",
  "verified_creative_tooltip": "인증된 사진작가 또는 창작 전문가",
  "favorite_airports": "즐겨찾는 공항",
  "no_favorite_airports": "아직 즐겨찾는 공항이 없습니다",
  "user_favorites": "사용자 즐겨찾기",
  "manage_favorites": "즐겨찾기 관리"
};
